import store from "../../stores";

export function eachRouteUpdate (to, from) {
    clearWatchers();
}

const watchers = {
    requireAuthModal: null,
    requireAuthStatus: null
}

function clearWatchers () {
    Object.keys(watchers).forEach(function (k) {
        if (typeof watchers[k] === 'function') {
            watchers[k]();
        }
        watchers[k] = null;
    })
}

export function requireAuth(to, from, next) {
    console.log('guard', 'requireAuth', from.name, to.name);
    clearWatchers();
    watchers.requireAuthModal = store.watch((state, getters) => state.loginModal.openState, () => {
        if (store.state.loginModal.openState === true) return;
        proceed(next);
    });
    /*watchers.requireAuthStatus = */store.watch((state, getters) => getters.isAuth, () => {
        // redirect if logout on auth required page
        proceed(next);
    });
    if (store.getters.isAuth) {
        next();
        return;
    }
    store.commit('loginModal/OPEN');
}

function proceed(next) {
    store.commit('loginModal/CLOSE');
    if (store.getters.isAuth) {
        next();
        return;
    }
    next({name: 'home'});
}



// WEBPACK FOOTER //
// ./src/router/guards/require-auth.guard.js